import React from "react";
import { NavLink, Link } from "react-router-dom";
import logo from '../../img/디아이캐스트로고.png';

const Nav = () => {
  return (
    <div className="flex justify-center">
      <div className="container flex justify-between w-full h-20 items-center px-4 md:h-28">
        <Link to="/">
          <div className="flex items-center">
          <h3 className="text-base font-bold text-blue-800 whitespace-nowrap mb-9 mr-40">인공지능 날씨</h3>
          <img src={logo} className="h-4 mb-9" alt="디아이캐스트 로고" />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Nav;